// Vocabulaire selon le métier de l'installation (Lot T0 — socle métier (transport)). Le métier vient de GET /api/settings (`business`,
// calculé par le serveur : absent = conciergerie). La conciergerie garde mot pour mot les textes d'avant.
// « mission » et « course » sont féminins, « employé » et « chauffeur » masculins : les phrases s'accordent
// de la même façon dans les deux métiers.
import { useSettings } from "@/context/SettingsContext";

export const VOCAB = {
  conciergerie: {
    tagline: "Conciergerie",
    loginOverline: "Conciergerie automobile de luxe",
    bookingTitle: "Réservez votre service de conciergerie automobile.",
    templateHeaderPlaceholder: "Conciergerie automobile de prestige",
    expenseLabelPlaceholder: "Ex. Badge parking, produits de lavage…",
    serviceTypeLabel: "Type de service", serviceTypePlaceholder: "Choisir un service",
    mission: "mission", missions: "missions", Mission: "Mission", Missions: "Missions",
    employee: "employé", employees: "employés", Employee: "Employé", ofEmployee: "de l'employé",
    journalDone: "Prestations réalisées", journalDay: "Prestations du jour", // Journal (lot T1b-2)
  },
  transport: {
    tagline: "Transport",
    loginOverline: "Transport de personnes avec chauffeur",
    bookingTitle: "Réservez votre chauffeur.",
    templateHeaderPlaceholder: "Transport de personnes avec chauffeur",
    expenseLabelPlaceholder: "Ex. Péage, parking, lavage du véhicule…",
    serviceTypeLabel: "Type de course", serviceTypePlaceholder: "Choisir une course",
    mission: "course", missions: "courses", Mission: "Course", Missions: "Courses",
    employee: "chauffeur", employees: "chauffeurs", Employee: "Chauffeur", ofEmployee: "du chauffeur",
    journalDone: "Courses réalisées", journalDay: "Courses du jour",
  },
};

// Dernier métier connu, gardé dans le navigateur : évite d'afficher la conciergerie une fraction de seconde
// sur une installation transport, le temps que les Réglages arrivent.
const CACHE_KEY = "fiableo-business";
export function rememberBusiness(business) {
  try { localStorage.setItem(CACHE_KEY, business); } catch {}
}
function cachedBusiness() {
  try { return localStorage.getItem(CACHE_KEY); } catch { return null; }
}

export function businessOf(settings) {
  const b = settings ? settings.business : cachedBusiness();
  return b === "transport" ? "transport" : "conciergerie";
}

export function useVocab() {
  const ctx = useSettings();
  const business = businessOf(ctx?.settings);
  return { business, ...VOCAB[business] };
}
